import React, { Component, Fragment } from 'react';
import HeaderContainer from "./template/HeaderContainer";
import ContentContainer from "./content/ContentContainer";
import FormContainer from "./AppointmentForm/FormContainer";
import ContentPlaceholder from "./ContentPlaceholder";

export default class App extends Component {
  render() {
    return (
      <div>
        <HeaderContainer/>
        {
          this.props.appointmentDisabled
            ? <ContentPlaceholder/>
            : <Fragment>
              <ContentContainer/>
              <FormContainer/>
            </Fragment>
        }
      </div>
    );

  }
}



// WEBPACK FOOTER //
// frontend/src/modules/App.jsx